import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function PackageOutlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M20.6201 2.08301H3.37988L1.08301 7.82324V19C1.08301 20.6084 2.3916 21.917 4 21.917H20C21.6084 21.917 22.917 20.6084 22.917 19V7.82324L20.6201 2.08301H20.6201ZM20.6457 7.08301H12.9072V3.91699H19.3799L20.6457 7.08301H20.6457ZM4.62012 3.91699H11.0928V7.08301H3.35431L4.62012 3.91699ZM20 20.083H4C3.40234 20.083 2.91699 19.5977 2.91699 19V8.91699H11.0928V13H12.9072V8.91699H21.083V19C21.083 19.5977 20.5976 20.083 20 20.083H20ZM15 16.083H19V17.917H15V16.083Z",
    fill: "currentColor"
  }));
}